// extracted by mini-css-extract-plugin
export default {"mainContainer":"borderedSection_mainContainer__EEFbA","childrenContainer":"borderedSection_childrenContainer__AoeXM"};